<template>
  <div id="Templates">


      <div class="mx--4">
        <div
          class="w-100 text-center total-carousel"
          v-if="themesList.length > 0 && startSlider != null"
        >
          <carousel-3d
            :minSwipeDistance="5"
            :startIndex="startSlider"
            :width="227"
            :height="324"
            :space="244"
            :disable3d="true"
            :controlsVisible="false"
            :clickable="true"
            :border="2"
            :dir="'ltr'"
            @before-slide-change="templateSliderChange"
          >
            <slide v-for="(n, index) in filteredThemesList" :key="n.id" :index="index">
              <div
                class="item"
                :style="{ 'background-color': colorsActive.highlightColor }"
                style="height: 100%"
              >
                <img :src="n.thumbnail" :alt="n.description" />
              </div>
            </slide>
          </carousel-3d>
        </div>

        <div v-else class="text-center">
          <h4>Carregando temas...</h4>
        </div>
      </div>

      <div class="text-left">
        <label class="subtext">
          <small>Paleta de cores</small>
        </label>
      </div>

      <div class="mx--4">
        <div class="total--colors scroll-custom">
          <div class="d-flex px-4 py-3">

            <div
              class="item--cor"
              v-for="(color, index) in filteredColorsList"
              :key="index"
              :class="[color.id == colorsActive.id ? 'item--active' : '']"
              :style="{ 'background-color': [color.background] }"
              @click="selectThisColor(color, index, false)"
            >
              <div class="title--color" :style="{ 'background-color': [color.titleColor] }">
                <div class="highlight--color" :style="{ 'background-color': [color.highlightColor] }"></div>
              </div>
            </div>

          </div>
        </div>
      </div>

  </div>
</template>
<script>
import axios from "axios";
import { Carousel3d, Slide } from "vue-carousel-3d";
export default {
  name: "Templates",
  data() {
    return {
      siteId: null,
      ROOT_API: null,
      indexColorActive: null,
      colorsActive: {
        id: 0,
        background: null,
        titleColor: null,
        highlightColor: null,
        colorTextButton: null
      },
      themesListAux: [],
      themesList: [],
      colorsList: [
        {
          id: 1,
          background: "#ffffff",
          titleColor: "#111111",
          highlightColor: "#111111",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 2,
          background: "#ffffff",
          titleColor: "#666666",
          highlightColor: "#111111",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 3,
          background: "#eeeeee",
          titleColor: "#111111",
          highlightColor: "#111111",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 4,
          background: "#FFFFFF",
          titleColor: "#666666",
          highlightColor: "#4D525C",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 5,
          background: "#FFFFFF",
          titleColor: "#555555",
          highlightColor: "#796262",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 6,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#FFFFFF",
          themeMode: "light",
          colorTextButton: "#111111"
        },
        {
          id: 7,
          background: "#EEEEEE",
          titleColor: "#111111",
          highlightColor: "#474E44",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 8,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#FFFFFF",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 9,
          background: "#222222",
          titleColor: "#CCCCCC",
          highlightColor: "#B2BEAE",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 10,
          background: "#111111",
          titleColor: "#CCCCCC",
          highlightColor: "#FFFFFF",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 11,
          background: "#222222",
          titleColor: "#CCCCCC",
          highlightColor: "#FFFFFF",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 12,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#111111",
          themeMode: "dark",
          colorTextButton: "#FFFFFF"
        },
        {
          id: 13,
          background: "#111111",
          titleColor: "#CCCCCC",
          highlightColor: "#B4BDD0",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 14,
          background: "#111111",
          titleColor: "#DDDDDD",
          highlightColor: "#AC9D9D",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 15,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#7EA8F0",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 16,
          background: "#F9F9F9",
          titleColor: "#111111",
          highlightColor: "#0F82FF",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 17,
          background: "#FFFFFF",
          titleColor: "#555555",
          highlightColor: "#3BCCD5",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 18,
          background: "#FFFFFF",
          titleColor: "#555555",
          highlightColor: "#06D6BA",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 19,
          background: "#FFFFFF",
          titleColor: "#999999",
          highlightColor: "#90CC90",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 20,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#34C688",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 21,
          background: "#FFFFFF",
          titleColor: "#555555",
          highlightColor: "#78B43A",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 22,
          background: "#222222",
          titleColor: "#FFFFFF",
          highlightColor: "#0F82FF",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 23,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#7EA8F0",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 24,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#3BCCD5",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 25,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#06D6BA",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 26,
          background: "#333333",
          titleColor: "#FFFFFF",
          highlightColor: "#9EE19E",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 27,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#34C688",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 28,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#78B43A",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 29,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#1A6638",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 30,
          background: "#F9F9F9",
          titleColor: "#777777",
          highlightColor: "#69A5BA",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 31,
          background: "#FFFFFF",
          titleColor: "#888888",
          highlightColor: "#FE859A",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 32,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#00A0E3",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 33,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#6828E8",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 34,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#3E017B",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 35,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#BA5E83",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 36,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#139145",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 37,
          background: "#222222",
          titleColor: "#888888",
          highlightColor: "#98C1D0",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 38,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#00A0E3",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 39,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#6828E8",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 40,
          background: "#222222",
          titleColor: "#BABABA",
          highlightColor: "#7D51A8",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 41,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#BA5E83",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 42,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#FE859A",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 43,
          background: "#FFFFFF",
          titleColor: "#999999",
          highlightColor: "#FDAAA2",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 44,
          background: "#EEEEEE",
          titleColor: "#111111",
          highlightColor: "#FF3E3E",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 45,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#D6071E",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 46,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#F75D37",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 47,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#FF3E3E",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 48,
          background: "#FFFFFF",
          titleColor: "#666666",
          highlightColor: "#E5007A",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 49,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#F9BC00",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 50,
          background: "#111111",
          titleColor: "#999999",
          highlightColor: "#FDAAA2",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 51,
          background: "#444444",
          titleColor: "#FFFFFF",
          highlightColor: "#FF3E3E",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 52,
          background: "#222222",
          titleColor: "#FFFFFF",
          highlightColor: "#FF3E3E",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 53,
          background: "#222222",
          titleColor: "#FFFFFF",
          highlightColor: "#ED1D1D",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 54,
          background: "#111111",
          titleColor: "#CCCCCC",
          highlightColor: "#E5007A",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 55,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#F75D37",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 56,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#F9BC00",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 57,
          background: "#FFFFFF",
          titleColor: "#888888",
          highlightColor: "#FEC167",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 58,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#E09D69",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 59,
          background: "#FFFFFF",
          titleColor: "#888888",
          highlightColor: "#EFCA00",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 60,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#AAAD7E",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 61,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#C48067",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 62,
          background: "#FFFFFF",
          titleColor: "#111111",
          highlightColor: "#B25151",
          themeMode: "light",
          colorTextButton: ""
        },
        {
          id: 63,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#FEC167",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 64,
          background: "#333333",
          titleColor: "#FFFFFF",
          highlightColor: "#FFEF00",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 65,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#AAAD7E",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 66,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#FFB67D",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 67,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#C48067",
          themeMode: "dark",
          colorTextButton: ""
        },
        {
          id: 68,
          background: "#111111",
          titleColor: "#FFFFFF",
          highlightColor: "#B25151",
          themeMode: "dark",
          colorTextButton: ""
        }
      ],
      startSlider: null,
      themeMode: "light",
      newTemplateId: null,
      customSchema: null,
      colorDirty: false
    };
  },
  props: {
    currentTemplate: {
      type: Number,
      required: true
    },
    saveData: {
      type: Boolean,
      required: false
    },
    source: {
      type: String,
      required: true
    }
  },
  methods: {
    templateSliderChange,
    findActiveTheme,
    selectThisColor,
    loadThemes,
    updateColorsSchema,
    getCustonSchema,
    getTemplates
  },
  components: {
    Carousel3d,
    Slide
  },
  created() {
    this.ROOT_API = process.env.ROOT_API;
    this.getTemplates();
    this.siteId = this.$session.get("siteId");
    if (this.source == "dashboard") {
      this.getCustonSchema();
    }
    this.newTemplateId = this.currentTemplate;
  },
  computed: {
    filteredColorsList() {
      return this.colorsList.filter(color => color.themeMode == this.themeMode);
    },
    filteredThemesList() {
      return this.themesList.filter(theme => theme.id >= 10);
    }
  },
  watch: {
    saveData() {
      if (this.saveData == true) {
        var template = {
          templateId: this.newTemplateId,
          customSchema: this.customSchema
        };
        let token = this.$session.get("jwt");
        axios({
          method: "post",
          url: `${this.ROOT_API}/api/site/${this.siteId}/template/update`,
          data: { contents: template },
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json"
          }
        })
          .then(function(response) {
            //handle success
            console.log(response);
          })
          .catch(function(response) {
            //handle error
            console.log("Erro ao salvar");
          });
        this.$store.commit("UPDATE_TEMPLATEID", this.newTemplateId);
        this.$emit("updateMenuOption");
      }
    }
  }
};
function templateSliderChange(index) {
  let activeTheme = this.themesList[index];
  this.themeMode = activeTheme.themeMode;
  if (this.indexColorActive >= 0) {
    this.colorsActive = this.filteredColorsList[this.indexColorActive];
  }
  if (this.customSchema != null) {
    this.customSchema = this.themesList[index].dataDecoded;
    this.updateColorsSchema();
  }
  if (this.source === "wizard") {
    this.$emit("updateTemplate", activeTheme.id);
    this.$emit("themeMode", this.themeMode);
  }
  this.newTemplateId = activeTheme.id;
  if (!this.colorDirty) {
    this.colorsActive = this.filteredColorsList[0];
  }
}
function findActiveTheme() {
  return new Promise(resolve => {
    let findStart = this.themesList.findIndex(
      item => item.id == this.currentTemplate
    );
    if (findStart >= 0) {
      this.startSlider = findStart;
    } else {
      this.startSlider = 0;
    }
    this.themeMode = this.themesList[this.startSlider].themeMode;
    resolve(true);
  });
}
function selectThisColor(color, index, automatic) {
  if (!automatic) {
    this.colorDirty = true;
  }
  this.indexColorActive = index;
  this.colorsActive = color;
  this.customSchema = this.filteredThemesList.find(
    theme => theme.id == this.newTemplateId
  ).dataDecoded;
  this.updateColorsSchema();
}
async function getTemplates() {
  this.themesList = await this.loadThemes();
  let activeThemeCheck = await this.findActiveTheme();
  if (activeThemeCheck) {
    this.colorsActive = this.filteredColorsList[0];
    this.selectThisColor(this.colorsActive, 0, true);
  }
}
function loadThemes() {
  return new Promise(resolve => {
    let token = this.$session.get("jwt");
    axios({
      method: "get",
      url: this.ROOT_API + "api/template",
      data: "",
      headers: {
        Authorization: "Bearer " + token
      }
    }).then(response => {
      resolve(response.data.content.filter(theme => theme.id >= 10));
    });
  });
}
function updateColorsSchema() {
  if (this.colorsActive.background != null) {
    this.customSchema.backgroundColor = this.customSchema.primaryColor = this.customSchema.secondaryColor = this.customSchema.inputBackgroundColor = this.customSchema.mobileBackgroundMenu = this.customSchema.colorSecondaryTextButton = this.customSchema.inputInvertBackgroundColor = this.customSchema.inputBackgroundSecundaryColor = this.customSchema.desktopBackgroundMenu = this.colorsActive.background;
  }

  if (this.colorsActive.highlightColor != null) {
    this.customSchema.colorHighlight = this.customSchema.backgroundColorButton = this.customSchema.primaryColor = this.colorsActive.highlightColor;
  }

  if (this.colorsActive.titleColor != null) {
    this.customSchema.titleColor = this.customSchema.footerTitleColor = this.colorsActive.titleColor;
  }

  if (this.colorsActive.colorTextButton != "") {
    this.customSchema.colorTextButton = this.colorsActive.colorTextButton;
  } else {
    this.customSchema.colorTextButton = this.colorsActive.background;
  }

  if (this.themeMode == "dark") {
    this.customSchema.backgroundSecondaryColor = "#171717";

    this.customSchema.colorTextMenu = this.customSchema.titleCoverColor = this.customSchema.titleSecondaryColor =
      "#fefefe";

    this.customSchema.textColor = this.customSchema.inputTextColor = this.customSchema.textCoverColor = this.customSchema.textSecondaryColor = this.customSchema.inputInvertTextColor = this.customSchema.inputTextSecundaryColor = this.customSchema.backgroundSecondaryColorButton = this.customSchema.footerTextColor =
      "#eeeeee";

    this.customSchema.inputBorderColor = this.customSchema.inputInvertBorderColor = this.customSchema.inputBorderSecundaryColor =
      "#cccccc";
  } else {
    this.customSchema.backgroundSecondaryColor = "#f9f9f9";

    this.customSchema.colorTextMenu = this.customSchema.titleCoverColor = this.customSchema.titleSecondaryColor =
      "#222222";

    this.customSchema.textColor = this.customSchema.inputTextColor = this.customSchema.textCoverColor = this.customSchema.textSecondaryColor = this.customSchema.inputInvertTextColor = this.customSchema.inputTextSecundaryColor = this.customSchema.backgroundSecondaryColorButton = this.customSchema.footerTextColor =
      "#4f4f4f";

    this.customSchema.inputBorderColor = this.customSchema.inputInvertBorderColor = this.customSchema.inputBorderSecundaryColor =
      "#b7b7b7";
  }

  this.$emit("updateColorSchema", this.customSchema);
}
function getCustonSchema() {
  let token = this.$session.get("jwt");
  axios({
    method: "get",
    url: `${this.ROOT_API}api/site/${this.siteId}/layout`,
    data: "",
    headers: {
      Authorization: "Bearer " + token
    }
  }).then(response => {
    this.customSchema = response.data.data;
  });
}
</script>
<style scoped>
.carousel-3d-container {
  margin-top: 0 !important;
}
.carousel-3d-slide {
  height: 325px !important;
  border-radius: 6px;
  border-color: rgba(0, 0, 0, 0.22);
  /* opacity: 0.6 !important; */
}
.carousel-3d-slide.current {
  border: 2px solid var(--main-color);
  opacity: 1 !important;
}
.total--colors {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  padding: 5px 5px 1rem;
}
.item--cor {
  border-radius: 6px;
  width: 70px;
  height: 50px;
  box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.2);
  margin-right: 10px;
  padding: 10px 28px 0 15px;
  border: 2px solid transparent;
}
.item--cor.item--active {
  box-shadow: 0 6px 16px 0px rgba(0, 0, 0, 0.2);
  border: 2px solid var(--main-color) !important;
}
.item--cor .title--color {
  width: 25px;
  height: 25px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  position: relative;
}
.item--cor .highlight--color {
  width: 25px;
  height: 25px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  right: -80%;
  position: absolute;
  top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Templates.vue